module.exports = __webpack_public_path__ + "static/media/hyundai-star.59ddc676.svg";